module.exports = __webpack_public_path__ + "static/media/licenta8.05b9eee9.png";